import { gsap } from 'gsap'

// Magnetic Buttons
// Found via: https://codepen.io/tdesero/pen/RmoxQg
export default class {
  constructor({ selector, strength }) {
    this.selector = selector instanceof HTMLElement ? selector : document.querySelectorAll(selector)
    this.strength = strength || 100

    //Methods
    this.initMagnetic()
  }

  initMagnetic() {
    this.selector.forEach((magnet) => {
      if (!magnet.classList.contains('initialised')) {
        magnet.classList.add('initialised')
        magnet.addEventListener('mousemove', (event) => {
          const magnetButton = event.currentTarget
          const bounding = magnetButton.getBoundingClientRect()

          gsap.to(magnetButton, {
            x: (((event.clientX - bounding.left) / magnetButton.offsetWidth) - 0.5) * this.strength,
            y: (((event.clientY - bounding.top) / magnetButton.offsetHeight) - 0.5) * this.strength,
            duration: 1,
            ease: 'Elastic.easeOut'
          })
        })
        magnet.addEventListener('mouseout', (event) => gsap.to(event.currentTarget, { x: 0, y: 0, duration: 1, ease: 'Elastic.easeOut' }))
      }
    })
  }

}